const styles = {
  container: 'w-full md:col-span-6',
  content: 'flex flex-col gap-y-4',

  foot: 'flex flex-row items-center justify-between h-4',

  label: '!text-xs font-bold !text-black',
  description: ' text-xs text-gray-600',
  error: 'text-[#E84F31] text-xs -translate-y-1 text-right',

  item: 'flex flex-col gap-y-1',

  submit: {
    container: 'w-full flex flex-col items-end justify-end mt-8',
    content: 'flex items-center gap-x-2',

    button:
      'inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-primary-950 dark:focus-visible:ring-[#F08E7A] bg-[#E84F31] text-white hover:bg-[#E84F31]/90 dark:bg-primary-50 dark:text-primary-900 dark:hover:bg-primary-50/90 h-10 px-5 py-2 rounded-sm   cursor-pointer z-10',
    icon: 'text-xs',
  },
};

export default styles;
